<ng-content select="sh-secnav-layout-topbanner"></ng-content>
<mat-drawer-container (backdropClick)="close()">
	<mat-drawer #secnav [disableClose]="true" [mode]="viewMode" [opened]="opened$ | async" class="mat-elevation-z8">
		<button mat-icon-button (click)="close()" *ngIf="isCloseButtonEnabled">
			<mat-icon matListIcon fontSet="prism-mat" fontIcon="keyboard_arrow_left"></mat-icon>
		</button>
		<ng-content select="sh-secnav-layout-secnav"></ng-content>
	</mat-drawer>
	<ng-content select="sh-secnav-layout-content"></ng-content>
</mat-drawer-container>
<ng-content select="sh-secnav-layout-footer"></ng-content>
